var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebook = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41076 12.0786V21.7496C9.41076 21.8894 9.52095 22 9.66014 22H13.2384C13.3775 22 13.4877 21.8894 13.4877 21.7496V11.9214H16.08C16.2076 11.9214 16.3178 11.8224 16.3294 11.6885L16.5788 8.73071C16.5904 8.58515 16.4744 8.45706 16.3294 8.45706H13.4877V6.35517C13.4877 5.86026 13.8879 5.46434 14.375 5.46434H16.3758C16.515 5.46434 16.6252 5.35371 16.6252 5.21397V2.25036C16.6252 2.11063 16.515 2 16.3758 2H13.0006C11.0172 2 9.41076 3.61281 9.41076 5.60408V8.45706H7.62456C7.48538 8.45706 7.37518 8.56769 7.37518 8.70742V11.6652C7.37518 11.8049 7.48538 11.9156 7.62456 11.9156H9.41076V12.0786Z",
    fill: "white",
    fillOpacity: 0.7
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.d56be953.svg";
export { ForwardRef as ReactComponent };